import { Injectable } from '@angular/core';
import { AlertDialogService } from '../../Services/Alert/alert.service'
import { FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { Component, OnInit, Input, EventEmitter } from '@angular/core';
//var address = require('address');
declare var $: any;

@Injectable({
    providedIn: 'root'
})
export class CommonService {
    constructor(private alert: AlertDialogService,
        private datePipe: DatePipe,) { }
    getmMac() {
        // address.ip();   // '192.168.0.2'
        // address.ipv6(); // 'fe80::7aca:39ff:feb0:e67d'
        // address.mac(function (err, addr) {
        //     console.log(addr); // '78:ca:39:b0:e6:7d'
        // });
    }
    getCurrentDate() {
        var today = new Date();
        var date = today.getDate();
        var dd = "", mm = "", todayFormat = "";
        var month = today.getMonth() + 1;
        var yyyy = today.getFullYear();
        if (date < 10) {
            dd = '0' + date;
        } else {
            dd = date + "";
        }

        if (month < 10) {
            mm = '0' + month;
        } else {
            mm = '' + month;
        }
        todayFormat = yyyy + '-' + mm + '-' + dd;
        return todayFormat;

    }

    isEmpty(obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }
    setCharAt(str, index, chr) {
        if (index > str.length - 1) return str;
        return str.substr(0, index) + chr + str.substr(index + 1);
    }
    keysToUpperCase(obj) {
        if (obj instanceof Array) {
            for (var i in obj) {
                obj[i] = this.keysToUpperCase(obj[i]);
            }
        }
        if (typeof (obj) !== "object" || typeof (obj) === "string" || typeof (obj) === "number" || typeof (obj) === "boolean") {
            return obj;
        }
        var keys = Object.keys(obj);
        var n = keys.length;
        var lowKey;
        while (n--) {
            var key = keys[n];
            if (key === (lowKey = key.toUpperCase()))
                continue;
            obj[lowKey] = this.keysToUpperCase(obj[key]);
            delete obj[key];
        }
        return (obj);
    }

    jsonKeysToCapitalize(object) {
        var isArray = Array.isArray(object);
        for (let key in object) {
            let value = object[key];
            let newKey = key;
            if (!isArray) { // if it is an object
                delete object[key]; // firstly remove the key
                newKey = key.toUpperCase(); // secondly generate new key (capitalized)
            }
            let newValue = value;
            if (typeof value != "object") { // if it is not an object (array or object in fact), stops here
                if (typeof value == "string") {
                    newValue = value.toUpperCase(); // if it is a string, capitalize it
                }
            } else { // if it is an object, recursively capitalize it
                newValue = this.jsonKeysToCapitalize(value);
            }
            object[newKey] = newValue;
        }
        return object;
    }

    checkDates(sDate, eDate, message) {
        if ((sDate != null && eDate != null) && (eDate) < (sDate)) {
            this.alert.openSnackBar(message, '');
            return false
        } else {
            return true;
        }
    }

    setDateToDatePicker(formGroup: FormGroup, formControlName, value) {
        if (this.validatedate(value.srcElement.value)) {
            // var pdate = value.srcElement.value.split('/');
            // var mm = parseInt(pdate[1]);
            // var dd = parseInt(pdate[0]);
            // var yy = parseInt(pdate[2]);
            // formGroup.get(formControlName).setValue(new Date(yy, mm - 1, dd));
            var pdate = value.srcElement.value.split('/');
            var mm = "";
            var dd = "";
            var yy = "";
            dd = pdate[0];
            mm = pdate[1];
            yy = pdate[2];
            if(parseInt(pdate[0])< 13){
                dd = pdate[1];
                mm = pdate[0];
            }
            //alert(yy + '-' + mm + '-' + dd + 'T00:00:00');
            formGroup.get(formControlName).setValue(yy + '-' + mm + '-' + dd + 'T00:00:00');
        } else {
            formGroup.get(formControlName).setValue('');
        }

    }



    validatedate(date) {
        let inputText = date;
        var dateformat = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/;
        // Match the date format through regular expression
        if (inputText.match(dateformat)) {

            //Test which seperator is used '/' or '-'
            var opera1 = inputText.split('/');
            var opera2 = inputText.split('-');
            let lopera1 = opera1.length;
            let lopera2 = opera2.length;
            // Extract the string into month, date and year
            if (lopera1 > 1) {
                var pdate = inputText.split('/');
            }
            else if (lopera2 > 1) {
                var pdate = inputText.split('-');
            }
            var mm = parseInt(pdate[1]);
            var dd = parseInt(pdate[0]);
            var yy = parseInt(pdate[2]);
            // Create list of days of a month [assume there is no leap year by default]
            var ListofDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
            if (mm == 1 || mm > 2) {
                if (dd > ListofDays[mm - 1]) {
                    // alert('Invalid date format!');

                    return false;
                }
            }
            if (mm == 2) {
                var lyear = false;
                if ((!(yy % 4) && yy % 100) || !(yy % 400)) {
                    lyear = true;
                }
                if ((lyear == false) && (dd >= 29)) {
                    // alert('Invalid date format!');

                    return false;
                }
                if ((lyear == true) && (dd > 29)) {
                    // alert('Invalid date format!');

                    return false;
                }
            }
            return true
        }
        else {
            // alert("Invalid date format!");

            return false;
        }
    }
    diff_weeks(dt2, dt1) {

        var diff = Math.abs(dt2.getTime() - dt1.getTime()) / 1000;
        diff /= (60 * 60 * 24 * 7);
        return Math.ceil(diff);

    }
    diff_days(dt2, dt1) {
        var Difference_In_Time = dt2 - dt1;
        return Difference_In_Time / (1000 * 3600 * 24);
    }
    leapYear(year) {
        return ((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0);
    }
    dateIsBetweenTwoDatesWithEqual(date, fromDate, toDate, message) {
        if ((date > fromDate || date.toDateString() == fromDate.toDateString()) && date <= toDate) {
            return true;
        } else {
            this.alert.openSnackBar(message, '');
            return false;
        }
    }
    jsonExcelGenerator = (function () {
        var tmplWorkbookXML = '<?xml version="1.0"?><?mso-application progid="Excel.Sheet"?><Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet" xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet">'
            + '<DocumentProperties xmlns="urn:schemas-microsoft-com:office:office"><Author>Axel Richter</Author><Created>{created}</Created></DocumentProperties>'
            + '<Styles>'
            + '<Style ss:ID="headerColumn"><Interior ss:Color="#3B5A9A" ss:Pattern="Solid" /><ss:Font ss:Color="white"/><ss:Alignment ss:Horizontal="Center" /></Style>'
            + '</Styles>', base64 = function (s) {
                return window.btoa(unescape(encodeURIComponent(s)))
            };
        return function (downloadName, data) {
            tmplWorkbookXML = '<?xml version="1.0"?><?mso-application progid="Excel.Sheet"?><Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet" xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet">'
                + '<DocumentProperties xmlns="urn:schemas-microsoft-com:office:office"><Author>Axel Richter</Author><Created>{created}</Created></DocumentProperties>'
                + '<Styles>'
                + '<Style ss:ID="headerColumn"><Interior ss:Color="#3B5A9A" ss:Pattern="Solid" /><ss:Font ss:Color="white"/><ss:Alignment ss:Horizontal="Center" /></Style>'
                + '</Styles>', base64 = function (s) {
                    return window.btoa(unescape(encodeURIComponent(s)))
                };
            var workbookXML = "";
            var worksheetsXML = "";
            var jdata = JSON.parse(data);
            var multiSheetExcel = jdata.Root.multiSheetExcel;
            if ($.isPlainObject(multiSheetExcel)) {
                multiSheetExcel = [multiSheetExcel];
            }
            for (var i = 0; i < multiSheetExcel.length; i++) {
                var headerColumn = multiSheetExcel[i].headerOrder.split(',');
                worksheetsXML += "<Worksheet ss:Name=\"" + multiSheetExcel[i].sheetName + "\">";
                var tableXML = '<Table>';
                if (multiSheetExcel[i].headerName) {
                    tableXML += '<Row><Cell ss:StyleID=\"headerColumn\" ss:MergeAcross="' + (headerColumn.length - 1) + '"><Data ss:Type="String">' + multiSheetExcel[i].headerName + '</Data></Cell></Row>';
                }
                var headerRowXML = '<Row>';
                var detailsRowXML = '';
                var dataType = "";
                $.each(headerColumn, function (k, headerCell) {
                    dataType = typeof multiSheetExcel[i].rowFild[headerCell] == 'number' ? 'Number' : 'String';
                    headerRowXML += "<Cell ss:StyleID=\"headerColumn\"><Data ss:Type=\"" + dataType + "\">" + multiSheetExcel[i].rowFild[headerCell] + "</Data></Cell>";
                });
                headerRowXML += '</Row>';
                tableXML += headerRowXML;
                $.isPlainObject(multiSheetExcel[i].rowData) ? (multiSheetExcel[i].rowData = [multiSheetExcel[i].rowData]) : multiSheetExcel[i].rowData;
                $.each(multiSheetExcel[i].rowData, function (k, rowCell) {
                    detailsRowXML += '<Row>';
                    $.each(headerColumn, function (k, headerCell) {
                        dataType = typeof rowCell[headerCell] == 'number' ? 'Number' : 'String';
                        detailsRowXML += "<Cell><Data ss:Type=\"" + dataType + "\">" + rowCell[headerCell] + "</Data></Cell>";
                    });
                    detailsRowXML += '</Row>';
                });
                tableXML += (detailsRowXML + "</Table>");
                worksheetsXML += (tableXML + "</Worksheet>");
            }
            worksheetsXML += "</Workbook>";
            tmplWorkbookXML += worksheetsXML;

            var link = document.createElement("a");
            (link as any).href = 'data:application/vnd.ms-excel;base64,' + base64(tmplWorkbookXML);
            (link as any).download = downloadName || 'Workbook.xls';
            (link as any).target = '_blank';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    })();



}